import type { PhotoInit, PhotoUploadState } from '@pms/shared';

import { request } from '../sync/api.js';

/** Куски маленькие, но сеть слабая — таймауты с запасом. */
const INIT_TIMEOUT_MS = 20_000;
const CHUNK_TIMEOUT_MS = 60_000;
const COMPLETE_TIMEOUT_MS = 60_000;

export function initPhoto(init: PhotoInit, deviceId: string): Promise<PhotoUploadState> {
  return request<PhotoUploadState>(
    '/api/photos/init',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Device-Id': deviceId },
      body: JSON.stringify(init),
    },
    INIT_TIMEOUT_MS,
  );
}

export function photoStatus(id: string, deviceId: string): Promise<PhotoUploadState> {
  return request<PhotoUploadState>(
    `/api/photos/${id}/status`,
    { method: 'GET', headers: { 'X-Device-Id': deviceId } },
    INIT_TIMEOUT_MS,
  );
}

export function putChunk(
  id: string,
  index: number,
  chunk: Blob,
  deviceId: string,
): Promise<PhotoUploadState> {
  return request<PhotoUploadState>(
    `/api/photos/${id}/chunks/${index}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/octet-stream', 'X-Device-Id': deviceId },
      body: chunk,
    },
    CHUNK_TIMEOUT_MS,
  );
}

export interface CompleteResponse {
  id: string;
  bytes: number;
  alreadyUploaded: boolean;
}

export function completePhoto(id: string, deviceId: string): Promise<CompleteResponse> {
  return request<CompleteResponse>(
    `/api/photos/${id}/complete`,
    {
      method: 'POST',
      // Тела у запроса нет, но тип указываем явно: иначе часть клиентов
      // подставляет свой и сервер отвечает «неподдерживаемый тип»
      headers: { 'Content-Type': 'application/json', 'X-Device-Id': deviceId },
      body: '{}',
    },
    COMPLETE_TIMEOUT_MS,
  );
}
